// import {
//   AiOutlineDashboard,
//   AiOutlineUser,
//   AiOutlinePaperClip,
//   AiFillHdd,
// } from "react-icons/ai";
// import { PiStudent } from "react-icons/pi";
// import { Layout, Menu } from "antd";
// import { Outlet, useNavigate } from "react-router-dom";

// const { Sider, Content } = Layout;

// const SuperAdminSidebar = ({ role }) => {
//   const navigate = useNavigate();

//   return (
//     <Layout>
//       <Sider
//         width={300}
//         style={{
//           height: "100vh",
//           position: "fixed",
//           left: 0,
//           top: 0,
//           bottom: 0,
//           //   zIndex: 1000,
//           backgroundColor: "#fff",
//         }}
//       >
//         <div className="bg-light p-2">
//           <h1 className="text-dark text-center">Admin Panel</h1>
//         </div>
//         <Menu
//           theme="light"
//           mode="inline"
//           defaultSelectedKeys={["dashboard"]}
//           onClick={({ key }) => {
//             if (key === "signout") {
//               // Handle sign out
//             } else {
//               navigate(key);
//             }
//           }}
//           items={[
//             {
//               key: "dashboard",
//               icon: <AiOutlineDashboard className="fs-4" />,
//               label: "Dashboard",
//             },

//             {
//               key: "postinternships",
//               icon: <PiStudent className="fs-4" />,
//               label: "Applications",
//               children: [
//                 {
//                   key: "totalapplication",
//                   icon: <AiFillHdd className="fs-4" />,
//                   label: "Total Applications",
//                 },
//                 {
//                   key: "approvedapplications",
//                   icon: <AiFillHdd className="fs-4" />,
//                   label: "Approved Applications",
//                 },
//                 {
//                   key: "rejectedapplication",
//                   icon: <AiFillHdd className="fs-4" />,
//                   label: "Rejected Applications",
//                 },
//                 {
//                   key: "pendingapplication",
//                   icon: <AiFillHdd className="fs-4" />,
//                   label: "Pending Applications",
//                 },
//                 {
//                   key: "students",
//                   icon: <AiFillHdd className="fs-4" />,
//                   label: "Closed Applications",
//                 },
//               ],
//             },
//           ]}
//         />

//         <div className="btn bg-danger btn-sm w-100 mt-3 text-white">logout</div>
//       </Sider>
//     </Layout>
//   );
// };

// export default SuperAdminSidebar;
import { useEffect, useState } from "react";
import {
  AiOutlineDashboard,
  AiOutlineUser,
  AiOutlinePaperClip,
  AiFillHdd,
} from "react-icons/ai";
import { FaBusinessTime, FaBlogger, FaPhotoVideo } from "react-icons/fa";
import { RiKakaoTalkLine } from "react-icons/ri";
import { MdFeedback } from "react-icons/md";
import { BiMenu, BiPodcast, BiSolidBusiness } from "react-icons/bi";
import { MdComputer, MdOutlinePoll } from "react-icons/md";
// import { Outlet } from "react-router-dom";
import { IoIosContact } from "react-icons/io";
import { PiStudent } from "react-icons/pi";
import { Layout, Menu } from "antd";
import { logoutAccess } from "../../store/stateFunctions";
import { Outlet, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { FcBusinessman } from "react-icons/fc";
import { GoOrganization } from "react-icons/go";

import { CiBoxList } from "react-icons/ci";
import { server } from "../../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../store/stateFunctions";
const { Sider, Content } = Layout;

const DivisionaOfficeSidebar = ({ role }) => {
  // const {
  //   token: { colorBgContainer },
  // } = theme.useToken();
  const navigate = useNavigate();
  const [selectedDivision, setSelectedDivision] = useState("All");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [approved, setApproved] = useState([]);
  const user = useSelectAccess(role);

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    setLoading(true);
    server
      .get(`/dashboard/userdashboard`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setData(response.data?.adminDetails);
          setApproved(response.data.totals);
        }
      })
      .catch((error) => {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else {
          toast.error(error.response?.data?.error || "An error occurred");
        }
      })
      .finally(() => setLoading(false));
  };

  console.log(data, "data here");
  return (
    <div>
      <div className="row bg-primary p-3 align-items-center">
        {/* Left side - Menu + Welcome */}
        <div className="col-md-4 d-flex align-items-center">
          <a
            className="bg-white p-2 rounded-3 border border-bottom border-2 border-dark shadow me-3 flex-shrink-0"
            data-bs-toggle="offcanvas"
            href="#offcanvasExample"
            role="button"
            aria-controls="offcanvasExample"
            id="side"
          >
            <BiMenu style={{ color: "black", fontSize: 25 }} />
          </a>

          {/* Prevent wrapping */}
          <h5 className="text-white m-0" style={{ whiteSpace: "nowrap" }}>
            Welcome To The Ahilyanagar Municipal Corporation, Ahilyanagar
          </h5>
        </div>

        {/* Right side - Admin Name + Role + Logout */}
        <div className="col-md-8 d-flex justify-content-end align-items-center">
          <div className="text-white me-3 text-end">
            <div className="fw-bold">{data?.name}</div>
            <div style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
              {data?.division} Division
            </div>
          </div>  
          <Button
            variant="contained"
            color="error"
            className="fw-bold"
            onClick={() => logoutAccess("Division Officer")}
          >
            Logout
          </Button>
        </div>
      </div>

      {/* Sidebar */}
      <ul className="nav">
        <li className="nav-item" id="sidebarm">
          <div
            className="offcanvas offcanvas-start"
            style={{ width: "20rem" }}
            tabIndex={-1}
            id="offcanvasExample"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div className="offcanvas-header bg-primary text-white ">
              <p id="size" className="fs-4">
                Super Admin
              </p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="offcanvas-body">
              <Sider width={300} style={{ height: "100vh" }}>
                <div style={{ height: "100%" }}>
                  <Menu
                    theme="light"
                    mode="inline"
                    defaultSelectedKeys={["dashboard"]}
                    onClick={({ key }) => {
                      if (key !== "signout") navigate(key);
                    }}
                    items={[
                      {
                        key: "dashboard",
                        icon: <AiOutlineDashboard className="fs-4" />,
                        label: "Dashboard",
                      },
                      {
                        key: "Applications",
                        icon: <FaBusinessTime className="fs-4" />,
                        label: "Applications",
                        children: [
                          {
                            key: "totalapplication",
                            icon: <AiFillHdd className="fs-4" />,
                            label: "Total Applications",
                          },
                          {
                            key: "approvedapplications",
                            icon: <AiFillHdd className="fs-4" />,
                            label: "Approved Applications",
                          },
                          {
                            key: "rejectedapplications",
                            icon: <AiFillHdd className="fs-4" />,
                            label: "Rejected Applications",
                          },
                          {
                            key: "pendingapplication",
                            icon: <AiFillHdd className="fs-4" />,
                            label: "Pending Applications",
                          },
                        ],
                      },
                    ]}
                  />
                </div>
              </Sider>
            </div>
          </div>
        </li>
      </ul>

      {/* Content */}
      <Content style={{ padding: 22 }}>{/* <Outlet /> */}</Content>
    </div>
  );
};

export default DivisionaOfficeSidebar;
